import { render, staticRenderFns } from "./DataSecurity.vue?vue&type=template&id=0af76eaa&"
import script from "./DataSecurity.vue?vue&type=script&lang=js&"
export * from "./DataSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports